export default __webpack_public_path__ + "static/any-185cf911975adc1cbad0321381e8b32a.png";